import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=135fcc29&scoped=true&"
import script from "./Shipping.vue?vue&type=script&async=true&lang=js&"
export * from "./Shipping.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=135fcc29&scoped=true&lang=scss&"
import style1 from "./Shipping.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fcc29",
  null
  
)

export default component.exports